import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GetRoutesForQuoteResponsePayload,
  CreateQuoteRoutePayload,
  UpdateQuoteRoutePayload,
} from '@cpak/adp-cpak-bff-service-models';
import {
  UpdateQuoteRouteRequestResponseData,
  GetCrmRoutesResponsePayload,
  UpsertQuoteRouteRequestRequestData,
  GetCrmApprovalsResponsePayload,
} from '@cpak/adp-cpak-quotes-service-models';
import { FetcherService } from './fetcher/fetcher.service';

@Injectable({
  providedIn: 'root',
})
export class RouteQuotesFetchService {
  constructor(private fetcher: FetcherService) {}

  public createNewRoute(
    id: string,
    data: UpsertQuoteRouteRequestRequestData
  ): Observable<CreateQuoteRoutePayload | null> {
    return this.fetcher.put(`/api/pages/quotes/routes/${id}`, data);
  }

  public getRouteByQuoteId(id: string): Observable<GetRoutesForQuoteResponsePayload | null> {
    return this.fetcher.get(`/api/pages/quotes/${id}/routes`);
  }

  public updatClearFromInboxStatus(
    id: string,
    response: UpdateQuoteRouteRequestResponseData
  ): Observable<UpdateQuoteRoutePayload | null> {
    const data = {
      response,
    };
    return this.fetcher.patch(`/api/pages/quotes/routes/${id}`, data);
  }

  public updateRoute(
    id: string,
    response: UpdateQuoteRouteRequestResponseData,
    newRequest?: UpsertQuoteRouteRequestRequestData
  ): Observable<UpdateQuoteRoutePayload | null> {
    const data = {
      response,
      newRequest,
    };
    return this.fetcher.patch(`/api/pages/quotes/routes/${id}`, data);
  }

  public getCRMRoutes(countryId: string, quoteId: string): Observable<GetCrmRoutesResponsePayload | null> {
    return this.fetcher.get(`/api/crmRoutes`, {
      countryIds: countryId,
      quoteId: quoteId,
    });
  }

  public getCRMApprovals(id: string): Observable<GetCrmApprovalsResponsePayload | null> {
    return this.fetcher.get(`/api/pages/quotes/${id}/routes/crmApprovals`);
  }
}
